import { jsx as _jsx } from "react/jsx-runtime";
import notFoundPng from '@/shared/assets/png/404.png';
import { useRouter } from '@core/rc-components';
import { Result, Image } from 'antd';
import { useMemo } from 'react';
import { IframePage } from './IframePage';
export const NotFound = () => {
    const { location } = useRouter();
    const pageDom = useMemo(() => {
        // 内嵌外链页面
        if (location.state?.component) {
            return _jsx(IframePage, { src: location.state?.component, title: location.state?.title });
        }
        // 默认展示404提示页面
        return _jsx(Result, { icon: _jsx(Image, { preview: false, src: notFoundPng, width: 600 }) });
    }, [location.pathname]);
    return pageDom;
};
